import React from "react";
import "./styles.css";
const TitleBar = ({ children }) => <div className="titleBar">{children}</div>;
export default TitleBar;
